<h1 class="container-heading">Logs</h1>

<mat-card>
    <mat-card-content>
        <div class="toolbar">
            <button mat-raised-button color="accent" (click)="openFilters()"
                    [matBadge]="filterCount"
                    [matBadgeHidden]="!filterCount"
                    matBadgePosition="above after"
                    matBadgeColor="warn" matBadgeSize="small">
                <mat-icon>filter_list</mat-icon>
                Filters
            </button>
            <span class="spacer"></span>
            <button mat-icon-button (click)="reload()" matTooltip="Refresh">
                <mat-icon>refresh</mat-icon>
            </button>
        </div>

        <table class="logs-table table">
            <thead>
            <tr>
                <th class="expander"></th>
                <th>Time</th>
                <th>Level</th>
                <th>Component</th>
                <th>Message</th>
                <th>Host</th>
                <th>Run</th>
                <th>Source</th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let row of logs">
                <tr class="log-row" [class.expanded]="expanded.has(row)" (click)="toggle(row)">
                    <td class="expander">
                        <mat-icon>{{ expanded.has(row) ? "expand_less" : "expand_more" }}</mat-icon>
                    </td>
                    <td class="nowrap">{{ time(row) }}</td>
                    <td><span [ngStyle]="levelStyle(row.level)">{{ row.level || "" }}</span></td>
                    <td>{{ row.component }}</td>
                    <td class="message">{{ row.message }}</td>
                    <td>{{ row.host }}</td>
                    <td>{{ row.run_id }}</td>
                    <td>{{ row.context?.at }}</td>
                </tr>
                <tr class="detail-row" *ngIf="expanded.has(row)">
                    <td [attr.colspan]="8">
                        <admin-logs-view [log]="row"></admin-logs-view>
                    </td>
                </tr>
            </ng-container>

            <tr *ngIf="!logs.length" class="empty">
                <td [attr.colspan]="8">No logs found.</td>
            </tr>
            </tbody>
        </table>

        <common-pagination *ngIf="pagination"
                            [data]="pagination"
                            pid="admin-logs"
                            [showTotal]="true"
                            (goToPage)="onPage($event)">
        </common-pagination>
    </mat-card-content>
</mat-card>